export default class QueriesController {
  #api;
  #paths;
  constructor(requestService, paths) {
    this.#api = requestService;
    this.#paths = paths;
  }

  async addNewProject({ newProjectBody }) {
    try {
      const path = this.#paths.myProjects.createProject;
      const { data } = await this.#api.Post(path, newProjectBody);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not save a new project.');
    }
  }

  async editTask({ taskId, taskData }) {
    try {
      const path = this.#paths.tasks.taskInfoOrEdit(taskId);
      const { data } = await this.#api.Put(path, taskData);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not update a task.');
    }
  }

  async createTask({ taskData }) {
    try {
      const path = this.#paths.tasks.newTask;
      const { data } = await this.#api.Post(path, taskData);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not save a new task.');
    }
  }

  async editProject({ projectId, editProjectBody }) {
    try {
      const path = this.#paths.myProjects.editProject(projectId);
      const { data } = await this.#api.Patch(path, editProjectBody);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not edit the project.');
    }
  }

  async deleteProject({ projectId, child }) {
    try {
      const path = this.#paths.myProjects.deleteProject(projectId);
      const { data } = await this.#api.Delete(path, { child });
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not delete the project.');
    }
  }

  async deleteTask({ taskId }) {
    try {
      const path = this.#paths.tasks.taskInfoOrEdit(taskId);
      const { data } = await this.#api.Delete(path);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not delete a task.');
    }
  }

  async updateTimeInATask({ state, tasksId }) {
    try {
      const path = this.#paths.tasks.updateTimeInTask(tasksId);
      const { data } = await this.#api.Patch(path, { state });
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I have not been able to update the task timer.');
    }
  }

  async updateTaskStatus({ taskId, status }) {
    try {
      const path = this.#paths.tasks.updateTaskStatus(taskId);
      const { data } = await this.#api.Put(path, status);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I have not been able to update the task status.');
    }
  }
}
